export const SOFTWARE_VERSION = '26.11.00';
